export default __webpack_public_path__ + "static/media/sticker-V.3e0a8f0f.png";